module.exports = "/_next/static/images/IlloUseCaseOptimizeAdSpendDefault-4d4167dedfec4741c9b841c633441cc3.png";